import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';
function norm(x){x=x||{};return Object.freeze({
 symbol:x.symbol||null,
 original:Object.freeze(Array.isArray(x.original)?x.original.slice():[]),
 current:Object.freeze(Array.isArray(x.current)?x.current.slice():[]),
 verification:['VERIFIED','PARTIAL','UNVERIFIED'].includes(x.verification)?x.verification:'UNVERIFIED',
 purchasedAt:x.purchasedAt||null
});}
function diff(input){
 const x=norm(input), a=new Set(x.original), b=new Set(x.current);
 const removed=[...a].filter(v=>!b.has(v)), added=[...b].filter(v=>!a.has(v));
 return Object.freeze({removed:Object.freeze(removed),added:Object.freeze(added),unchanged:Object.freeze([...a].filter(v=>b.has(v)))});
}
function state(input){
 const x=norm(input), d=diff(x);
 if(x.verification==='UNVERIFIED'&&(d.added.length||d.removed.length)) return 'UNVERIFIED_DRIFT';
 if(d.removed.length>=2) return 'MATERIAL_DRIFT';
 if(d.removed.length===1||d.added.length>=2) return 'REVIEW_DRIFT';
 if(d.added.length===1) return 'MINOR_DRIFT';
 return 'STABLE';
}
function challenge(input){
 const x=norm(input), d=diff(x), s=state(x);
 return Object.freeze({
  symbol:x.symbol,state:s,removed:d.removed,added:d.added,
  purchasePriceRelevant:false,
  tradeSignal:false,
  prompt:s==='STABLE'?'Original thesis remains structurally consistent.':'Review whether the current story still matches the original evidence-backed thesis.'
 });
}
function selfTest(){
 const t=[],ok=(a,b)=>t.push({name:a,pass:!!b});
 const base={symbol:'AAA',original:['MOAT','GROWTH','FCF'],current:['MOAT','GROWTH','FCF'],verification:'VERIFIED'};
 ok('unchanged thesis is stable',state(base)==='STABLE');
 ok('one removed pillar creates review drift',state({...base,current:['MOAT','GROWTH']})==='REVIEW_DRIFT');
 ok('two removed pillars create material drift',state({...base,current:['MOAT']})==='MATERIAL_DRIFT');
 ok('unverified drift stays unverified',state({...base,current:['MOAT'],verification:'UNVERIFIED'})==='UNVERIFIED_DRIFT');
 const d=diff({...base,current:['MOAT','GROWTH','NEW_CATALYST']});
 ok('added thesis element is detected',d.added.includes('NEW_CATALYST'));
 ok('removed elements are explicit',diff({...base,current:['MOAT']}).removed.length===2);
 const c=challenge({...base,current:['MOAT']});
 ok('purchase price is excluded from thesis logic',c.purchasePriceRelevant===false);
 ok('challenge remains non-trading',c.tradeSignal===false);
 ok('challenge text exists',c.prompt.length>0);
 ok('stable challenge is non-alarmist',challenge(base).prompt.includes('consistent'));
 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,diff,state,challenge,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestThesisDriftEngine=Object.freeze(API);
})(engineContext);
